// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPackages_root__2QxJc","closeButton":"SelectPackages_closeButton__2aqN5"};